/* globals global, document */
import { showError } from 'utils/messages';
import EasyPostConstants from 'app/easypost_constants';

export function appUrl(path) {
  return `/api/v2/${path}`;
}

export function fulfillmentUrl(path) {
  return `/api/fulfillment/vendor/v1/${path}`;
}

export function analyticsUrl(path) {
  return `/api/analytics/${path}`;
}

export function trackingPageUrl(path) {
  return `${EasyPostConstants.TrackingPageBase}/${path}`;
}

export function $contentArea() {
  return $body().find('#content-area');
}

export function $body() {
  return $('body');
}

export function location() {
  return window.location;
}

export function setLocation(l) {
  window.location = l;
}

export function $window() {
  return $(window);
}

export function scrollTop(offset) {
  return $window().scrollTop(offset || 0);
}

global.skipTimeouts = global.skipTimeouts || false;

export function setSkipTimeouts(val) {
  global.skipTimeouts = !!val;
}

export function setTimeout(fn, timeout) {
  if (global.skipTimeouts) {
    return fn();
  }

  return window.setTimeout(fn, timeout);
}

export function currentHash() {
  return location().hash;
}

export function getQueryParams() {
  // Adapted from http://www.joezimjs.com/javascript/3-ways-to-parse-a-query-string-in-a-url/
  const queryString = location().search.substring(1);

  /* eslint no-param-reassign: 0 */
  return queryString.split('&').reduce((o, q) => {
    const temp = q.split('=');
    o[temp[0]] = temp[1];
    return o;
  }, {});
}

export function submitPostViaHiddenForm(url, params) {
  const form = $('<form target="_blank" method="POST" style="display:none;"></form>').attr({
    action: url
  }).appendTo(document.body);

  Object.keys(params).forEach((key) => {
    $('<input type="hidden">').attr({
      name: key,
      value: params[key]
    }).appendTo(form);
  });
  form.submit();
  form.remove();
}

export function getFileReader() {
  return new window.FileReader();
}

export function errorIfNoFileReader(input) {
  if (!window.FileReader || !input.files || !input.files[0]) {
    const errMsg = 'Sorry, your browser doesn\'t support file uploads (FileReader API).';
    showError(errMsg);
    throw new Error(errMsg);
  }
}

export function downloadStringAsFile(string, filename) {
  const element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(string));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}



// WEBPACK FOOTER //
// ./utils/wrappers.js